import React, { useEffect } from 'react'
import { useAtomValue } from 'jotai'
import {
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetError,
  UseFormSetValue,
  UseFormTrigger,
} from 'react-hook-form'
import { Box } from '@node-space/ui-components'
import { contactAtom } from 'pages/Contacts/atoms/contactAtoms'
import { ContactFiatInstrumentFormData } from 'pages/Contacts/schemas/contactFiatInstrumentSchema'
import { FormFieldLabels } from 'pages/Contacts/types/fiatInstruments'
import { BeneficiaryDetails, BeneficiaryEntityType } from 'types/beneficiaries'
import { ContactEntity } from 'types/contacts'
import { BankDetails } from './BankDetails'

type BankAccountDetailsProps = {
  formValues: ContactFiatInstrumentFormData
  errors: FieldErrors<ContactFiatInstrumentFormData>
  isBusinessAccount: boolean
  isInternationalBankAccount: boolean
  formFieldLabels: FormFieldLabels
  clearErrors: UseFormClearErrors<ContactFiatInstrumentFormData>
  setValue: UseFormSetValue<ContactFiatInstrumentFormData>
  register: UseFormRegister<ContactFiatInstrumentFormData>
  trigger: UseFormTrigger<ContactFiatInstrumentFormData>
  setError: UseFormSetError<ContactFiatInstrumentFormData>
  contactBeneficiary?: BeneficiaryDetails
}
export const BankAccountDetails = ({
  formValues,
  errors,
  isBusinessAccount,
  isInternationalBankAccount,
  formFieldLabels,
  clearErrors,
  setValue,
  register,
  trigger,
  setError,
  contactBeneficiary,
}: BankAccountDetailsProps) => {
  const contact = useAtomValue(contactAtom)

  useEffect(() => {
    if (contact?.entity?.type) {
      const entityType =
        contact.entity.type === ContactEntity.COMPANY
          ? BeneficiaryEntityType.BUSINESS
          : BeneficiaryEntityType.INDIVIDUAL
      setValue('entityType', entityType)
    }
  }, [contact?.entity?.type])

  return (
    <Box width="full">
      <Box flexCol width="full" gapY={16} paddingB={isInternationalBankAccount ? null : 12}>
        <BankDetails
          formFieldLabels={formFieldLabels}
          formValues={formValues}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          register={register}
          trigger={trigger}
          setError={setError}
          contactBeneficiary={contactBeneficiary}
        />
      </Box>
    </Box>
  )
}
